import CustomFieldsList from './CustomFieldsList';

export default CustomFieldsList;
